import { createApp } from "vue";
import store from "../../common/js/store";
import registerServiceWorker from "./serviceWorkerRegistration";

// Global components import
import HtmlComponent from "../../common/js/components/HtmlComponent.vue";
import Search from "../../common/js/components/Search.vue";
import SearchModal from "../../common/js/components/SearchModal.vue";
import InlineNotification from "../../common/js/components/InlineNotification.vue";
import HorizontalCarousel from "../../common/js/components/HorizontalCarousel.vue";
import DynamicBanner from "../../common/js/components/DynamicBanner.vue";
import HeroBanners from "../../common/js/components/HeroBanners.vue";
import Offers from "../../common/js/components/Offers.vue";
import GenericModal from "../../common/js/components/GenericModal.vue";
import OfferSelectedPopup from "../../common/js/components/OfferSelectedPopup.vue";
import PreviousOrder from "../../common/js/components/PreviousOrder.vue";
import BrowseMenu from "../../common/js/components/BrowseMenu.vue";
import OrderType from "../../common/js/components/OrderType.vue";
import ProfileIcon from "../../common/js/components/ProfileIcon.vue";
import VerticalProductScroll from "../../common/js/components/VerticalProductScroll.vue";
import BottomBar from "../../common/js/components/BottomBar.vue";
import ProductFilters from "../../common/js/components/ProductFilters.vue";
import AddressCard from "../../common/js/components/AddressCard.vue";
import TakeAwayPage from "../../common/js/components/TakeAwayPage.vue";
import InitializeStore from "../../common/js/components/InitializeStore.vue";
import HorizontalBannerWithText from "../../common/js/components/HorizontalBannerWithText.vue";
import CustomizationInit from "../../common/js/components/CustomizationInit.vue";
import HomePageUserAddress from "../../common/js/components/HomePageUserAddress.vue";
import BottomBarMenuModal from "../../common/js/components/BottomBarMenuModal.vue";
import ProductCardModal from "../../common/js/components/ProductCardModal.vue";
import ThankYou from "../../common/js/components/ThankYou.vue";
import OfferCard from "../../common/js/components/OfferCard.vue";
import Upsell from "../../common/js/components/Upsell.vue";
import OrderDetails from "../../common/js/components/OrderDetails.vue";
import ToastMsg from "../../common/js/components/ToastMsg.vue";
import NoInternetScreen from "../../common/js/components/NoInternetScreen.vue";
import LocationNotFound from "../../common/js/components/LocationNotFound.vue";
import ServerErrorScreen from "../../common/js/components/ServerErrorScreen.vue";
import Loader from "../../common/js/components/Loader.vue";
import MiniLogin from "../../common/js/components/MiniLogin.vue";
import BottomBarHome from "../../common/js/components/BottomBarHome.vue";
import HorizontalBannerTopLatest from "../../common/js/components/HorizontalBannerTopLatest.vue";
import BottomStaticMessage from "../../common/js/components/BottomStaticMessage.vue";
import FetchLocation from "../../common/js/components/FetchLocation.vue";
import LocationPermissionPopup from "../../common/js/components/LocationPermissionPopup.vue";
import ProductCategoryGrid from "../../common/js/components/ProductCategoryGrid.vue";
import OrderTypeDropdown from "../../common/js/components/OrderTypeDropdown.vue";
import StoreUnavailableHeader from "../../common/js/components/StoreUnavailableHeader.vue";
import ScrollToTopFloatingButton from "../../common/js/components/ScrollToTopFloatingButton.vue";
import WhatMakesUsDifferent from "../../common/js/components/WhatMakesUsDifferent.vue";
import NotificationWidget from "../../common/js/components/NotificationWidget.vue";
import ItemRemovePopup from "../../common/js/components/ItemRemovePopup.vue";
import HomePageShimmer from "../../common/js/components/HomePageShimmer.vue";
import FeedbackCard from "../../common/js/components/FeedbackCard.vue";
import Ripple from "../../common/js/helpers/ripple";
import NgTrackOrder from "../../common/js/components/NgTrackOrder.vue";

const app = createApp({});
app.use(store);

// Global components registration
// @todo: similarly all other components registration currently inside Home.vue will move here and Home.vue will be discarded
app.directive("ripple", Ripple);
app.component("html-component", HtmlComponent);
app.component("horizontal-carousel", HorizontalCarousel);
app.component("dynamic-banner", DynamicBanner);
app.component("hero-banners", HeroBanners);
app.component("offers", Offers);
app.component("generic-modal", GenericModal);
app.component("offer-selected-popup", OfferSelectedPopup);
app.component("browse-menu", BrowseMenu);
app.component("menu-modal", BottomBarMenuModal);
app.component("order-type", OrderType);
app.component("profile-icon", ProfileIcon);
app.component("vertical-product-scroll", VerticalProductScroll);
app.component("product-filters", ProductFilters);
app.component("address-card", AddressCard);
app.component("take-away-page", TakeAwayPage);
app.component("initialize-store", InitializeStore);
app.component("search", Search);
app.component("search-modal", SearchModal);
app.component("inline-notification", InlineNotification);
app.component("previous-order", PreviousOrder);
app.component("bottom-bar", BottomBar);
app.component("horizontal-banner-with-text", HorizontalBannerWithText);
app.component("customization-init", CustomizationInit);
app.component("product-card-modal", ProductCardModal);
app.component("thank-you", ThankYou);
app.component("home-page-user-address", HomePageUserAddress);
app.component("offer-card", OfferCard);
app.component("upsell", Upsell);
app.component("order-details", OrderDetails);
app.component("toast-msg", ToastMsg);
app.component("no-internet-screen", NoInternetScreen);
app.component("location-not-found", LocationNotFound);
app.component("server-error-screen", ServerErrorScreen);
app.component("loader", Loader);
app.component("mini-login", MiniLogin);
app.component("bottom-bar-home", BottomBarHome);
app.component("best-seller-top-10", HorizontalBannerTopLatest);
app.component("bottom-static-message", BottomStaticMessage);
app.component("fetch-location", FetchLocation);
app.component("location-permission-popup", LocationPermissionPopup);
app.component("product-category-grid", ProductCategoryGrid);
app.component("order-type-dropdown", OrderTypeDropdown);
app.component("store-unavailable-header", StoreUnavailableHeader);
app.component("scroll-to-top-floating-button", ScrollToTopFloatingButton);
app.component("what-makes-us-different", WhatMakesUsDifferent);
app.component("notification-widget", NotificationWidget);
app.component("item-remove-popup", ItemRemovePopup);
app.component("home-page-shimmer", HomePageShimmer);
app.component("nps-feedback", FeedbackCard);
app.component("ng-track-order", NgTrackOrder);
app.mount("#themeDefault");

registerServiceWorker();

if (typeof window != "undefined") {
  window.onbeforeunload = () => {
    window.scrollTo(0, 0);
  };
}
